import {
  addItemToCart,
  applyCredit1,
  applyDiscount,
  getCart1,
  getCartById,
  getOrderByCartId1,
  removeCredit1,
  removeDiscount,
  removeLineItem,
  updateDeliveryDetails,
  updateShippingAddress,
} from "@/generated/api/sdk.gen"
import type { AddCartItemRequest, UpdateDeliveryDetailsRequest, UpdateShippingAddressRequest } from "@/generated/api/types.gen"
import type { Api } from "@/platform/api/api"
import { body, conversionHeaders, orNull } from "@/platform/api/gateways/common"

export const cartGateway = (api: Api) => ({
  current: () => orNull(body(getCart1(api.request()))),

  byId: (cartId: string) => body(getCartById({ ...api.request(), path: { cartId } })),

  addItem: (request: AddCartItemRequest, conversionId?: string, idempotencyKey?: string) =>
    body(
      addItemToCart({
        ...api.request({ headers: { ...conversionHeaders(conversionId), ...(idempotencyKey ? { "Idempotency-Key": idempotencyKey } : {}) } }),
        body: request,
      })
    ),

  removeItem: (lineItemId: string) => body(removeLineItem({ ...api.request(), path: { lineItemId } })),

  applyDiscount: (code: string) => body(applyDiscount({ ...api.request(), body: { code } })),

  removeDiscount: (code: string) => body(removeDiscount({ ...api.request(), path: { code } })),

  updateShippingAddress: (request: UpdateShippingAddressRequest) => body(updateShippingAddress({ ...api.request(), body: request })),

  updateDeliveryDetails: (request: UpdateDeliveryDetailsRequest) => body(updateDeliveryDetails({ ...api.request(), body: request })),

  applyCredit: () => body(applyCredit1(api.request())),

  removeCredit: () => body(removeCredit1(api.request())),

  orderByCart: async (cartId: string) => (await body(getOrderByCartId1({ ...api.request(), path: { cartId } }))).order,
})

export type CartGateway = ReturnType<typeof cartGateway>
